import type {AdSample} from '../types/AdSample';
import type {Sample} from '../types/Sample';

import type {Backend} from './Backend';

/**
 * The `QueueBackend` class is responsible for queuing samples for deferred processing.
 * Samples are stored in different queues depending on the sample type and can be flushed
 * to another backend for further processing.
 *
 * This is useful e.g. to still collect sample data while waiting for a license call to succeed.
 *
 * @implements {Backend}
 */
export class QueueBackend implements Backend {
  private readonly queue: Sample[] = [];
  private readonly unloadQueue: Sample[] = [];
  private readonly adQueue: AdSample[] = [];
  private readonly unloadAdQueue: AdSample[] = [];

  sendRequest(sample: Sample): void {
    this.queue.push(sample);
  }
  sendUnloadRequest(sample: Sample): void {
    this.unloadQueue.push(sample);
  }
  sendAdRequest(adSample: AdSample): void {
    this.adQueue.push(adSample);
  }
  sendUnloadAdRequest(adSample: AdSample): void {
    this.unloadAdQueue.push(adSample);
  }

  flushTo(backend: Backend) {
    this.queue.forEach((e) => {
      backend.sendRequest(e);
    });
    this.unloadQueue.forEach((e) => {
      backend.sendUnloadRequest(e);
    });
    this.adQueue.forEach((e) => {
      backend.sendAdRequest(e);
    });
    this.unloadAdQueue.forEach((e) => {
      backend.sendUnloadAdRequest(e);
    });
  }
}
